import { defineStore } from 'pinia'

import { getNotifications, updateNotification } from '@/api/notifications-routes'

import { mapNotificationFromApi } from '@/helpers/notification-helper'

import { useDefaultStore } from '@/store/defaultStore'

export const useNotificationsStore = defineStore('notificationsStore', {
    state: () => ({
        loading: false,
        loadingRead: false,
        notifications: [],
        notificationInterval: null,
        loadingReadIds: {},
        smallNotificationMenu: true,
    }),

    getters: {
        unreadNotifications(state) {
            return state.notifications.filter((notification) => !notification.read_at)
        },

        lastUnreadUrgentlyNotification() {
            return this.unreadNotifications.find((notification) => notification.type === 'recommendation')
        },

        readNotifications(state) {
            return state.notifications.filter((notification) => notification.read_at)
        },
    },

    actions: {
        changeSmallNotificationMenu(value) {
            this.smallNotificationMenu = value
        },

        async loadNotifications() {
            const defaultStore = useDefaultStore()
            this.loading = true

            const { success, payload, message } = await getNotifications()

            if (success) {
                this.notifications = payload.map(mapNotificationFromApi)
            } else {
                defaultStore.setErrorMessage({ message })
            }

            this.loading = false
        },

        addNotification(notification) {
            this.smallNotificationMenu = true
            this.notifications.push(notification)
        },

        async onRead(id) {
            const defaultStore = useDefaultStore()

            if (id && this.loadingReadIds[id]) {
                return
            }

            if (!id && this.loadingRead) {
                return
            }

            this.setLoadingReadId({ id })

            const { success, message } = await updateNotification(id)

            if (success) {
                this.notificationsAfterRead(id)
                defaultStore.setSuccessMessage({ message })
            } else {
                defaultStore.setErrorMessage({ message })
            }

            this.setLoadingReadId({ id, loading: false })
        },

        setLoadingReadId({ id, loading = true }) {
            if (id) {
                this.loadingReadIds[id] = loading
            } else {
                this.loadingRead = loading
            }
        },

        notificationsAfterRead(id) {
            if (id) {
                const index = this.notifications.findIndex((item) => item.id === id)

                if (index !== -1) {
                    this.notifications.splice(index, 1, { ...this.notifications[index], read_at: new Date() })
                }
            } else {
                this.markAsReadAllNotifications()
            }
        },
        markAsReadAllNotifications() {
            this.notifications.forEach((notification) => {
                notification.read_at = new Date()
            })
        },
    },
})
